import { ShieldCheck } from "lucide-react";
import { Reveal } from "./Reveal";

export default function Garantia() {
  return (
    <section className="px-4 pb-16 sm:px-6 md:pb-24 lg:px-8 lg:pb-32" data-testid="hidropro-warranty-cdc-block">
      <div className="mx-auto max-w-7xl">
        <Reveal>
          <div className="relative overflow-hidden rounded-2xl bg-brand-navy px-8 py-12 sm:px-12 lg:px-16 lg:py-16">
            <div className="absolute inset-0 bg-blueprint-dark" />
            <div
              className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full"
              style={{ background: "radial-gradient(circle, rgba(0,163,224,0.25) 0%, transparent 70%)" }}
            />
            <div className="relative flex flex-col items-start gap-8 lg:flex-row lg:items-center lg:gap-12">
              <span className="flex h-20 w-20 shrink-0 items-center justify-center rounded-2xl bg-water/15 text-water sm:h-24 sm:w-24">
                <ShieldCheck className="h-10 w-10 sm:h-12 sm:w-12" />
              </span>
              <div>
                <p className="font-mono text-xs uppercase tracking-[0.25em] text-water">Garantia</p>
                <p className="mt-3 max-w-3xl font-display text-xl font-bold leading-snug text-white sm:text-2xl lg:text-[1.8rem]">
                  Condições de garantia informadas antes da contratação, conforme a natureza do serviço e a legislação
                  vigente.
                </p>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
